import {useRsvp} from "../context/RsvpContext";
import LogoutButton from "./LogoutButton";
import {Outlet} from "react-router-dom";

const ProtectedLayout: React.FC = () => {
    const { rsvp, isLoading } = useRsvp();
    const showLogout = rsvp && !isLoading;
    return (
        <div>
            {showLogout && <LogoutButton/>}
            <Outlet/>
        </div>
    );
}

export default ProtectedLayout;